import parseISO from 'date-fns/parseISO';
import format from 'date-fns/format';

export const getDate = (date) => {
    const parsedDate = parseISO(date);
    return format(parsedDate, 'EEEE, MMMM dd');
};
export const getTime = (date) => {
    const parsedDate = parseISO(date);
    return format(parsedDate, 'h:mm aa ');
};

export const formatDateRange = (start, end) => {
    const startDate = new Date(start);
    const endDate = new Date(end);

    const options = { month: 'long', day: 'numeric', year: 'numeric' };
    const startDateString = startDate.toLocaleDateString('en-US', options);
    const startTimeString = startDate.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
    const endDateString = endDate.toLocaleDateString('en-US', options);
    const endTimeString = endDate.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
    if (endDateString !== startDateString) {
        return `${startDateString} ${startTimeString} - ${endDateString} ${endTimeString}`;
    }

    if (startTimeString === endTimeString || !endTimeString) {
        return `${startDateString} ${startTimeString}`;
    }
    return `${startDateString} | ${startTimeString} - ${endTimeString}`;
};
